<template>
  <v-container fluid fill-height style="padding: 0; height: 60rem">
    <v-col id="map" ref="map" cols="12" xs12 sm12 md12 style="height: inherit; position: relative">
      <Draggable v-if='draggable_open' :title='siteName' :starting-x-pos='positionOfXClick' @closed='toggleContainerOpen(false)'>
        <v-select v-model='tableChartOption' label="Summary view" outlined :items="containerDisplayOptions" :full-width='true' hide-details></v-select>
        <MixedChart v-show='chartData.length > 0 && tableChartOption === "Site bar chart summary"' :data='chartData'></MixedChart>
        <DataTable v-show='chartData.length > 0 && tableChartOption === "Table summary"' :data='tableData.data' :headers='tableData.headers'></DataTable>
        <v-alert v-show='chartData.length === 0' color="orange" style='margin:15px' outlined>No data available</v-alert>
        <v-row>
          <v-col cols='8'>
            <ul style='list-style: none;font-size: 18px;'>
              <li v-for='(value, name, index) in selectedFeatureTooltipInfo' :key='index'>
                <span style='text-transform: capitalize;'>{{ name.replace(/([a-z])([A-Z])/g, '$1 $2') }}:</span>&nbsp;<strong>{{ value }}</strong>
                  </li>
                </ul>
          </v-col>
          <v-col cols='4' align-self="end" class="text-center">
            <!-- <v-img
              src="https://bad.src/not/valid"
              lazy-src="@/assets/gradient_bg.png"
              max-width="400"
              max-height="300"
            >
              <template v-slot:placeholder>
                <v-row
                  class="fill-height ma-0"
                  align="center"
                  justify="center"
                >
                  <v-progress-circular
                    indeterminate
                    color="grey lighten-5"
                  ></v-progress-circular>
                </v-row>
              </template> -->
            <!-- </v-img> -->
            <a
              class='google-redirect'
              target='_blank'
              @click="handleGoogleRedirect"

            >Google Maps Link (new window)</a>
          </v-col>
        </v-row>
      </Draggable>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <div id="layerctrl">
            <v-btn class="px-1" v-bind="attrs" color="#6690ba" v-on="on" @click="toggleSatLayer">
              <v-icon color="#fff"> mdi-layers </v-icon>
            </v-btn>
          </div>
        </template>
        <span>Toggle Satellite Layer</span>
      </v-tooltip>
      <div v-show="search === 'location'">
        <v-text-field v-model="locationSearch" label="location search" class="site-location-search-input" placeholder="Lat,Lng" prepend-inner-icon="mdi-map-marker" solo @keydown="searchLocation"
          @click:prepend-inner="toggleSearchLayer('site')"></v-text-field>
      </div>
      <div v-show="search === 'site'">
        <v-autocomplete v-model="mapSite" class="site-location-search-input" placeholder="Site" solo prepend-inner-icon="mdi-map-marker-off" :items="getMapLocations"
          item-text="id" item-value="id" return-object @click:prepend-inner="toggleSearchLayer('location')"></v-autocomplete>
      </div>
    </v-col>
  </v-container>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import Map from 'ol/Map';
// eslint-disable-next-line no-unused-vars
import View from 'ol/View';
import * as proj from 'ol/proj';
// eslint-disable-next-line no-unused-vars
import Point from 'ol/geom/Point';
import TileLayer from 'ol/layer/Tile';
import { Group as LayerGroup } from 'ol/layer';
// eslint-disable-next-line no-unused-vars
import Feature from 'ol/Feature';
// eslint-disable-next-line no-unused-vars
import { Vector, OSM, Cluster } from 'ol/source';
import LayerVector from 'ol/layer/Vector';
import Select from 'ol/interaction/Select';
import { Style, Stroke, Fill, Circle } from 'ol/style';
// import LayerVector from "ol/layer/Vector";
// import Select from "ol/interaction/Select";
import OlPopup from 'ol-ext/overlay/Popup';
import XYZ from 'ol/source/XYZ';
// eslint-disable-next-line import/no-unresolved
// import proj4 from "proj4";
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import 'ol/ol.css';
import 'ol-geocoder/dist/ol-geocoder.min.css';
import 'ol-ext/overlay/Popup.css';
import * as Geocoder from 'ol-geocoder';
import '../assets/css/material-design-iconic-font.min.css';
import { defaults as defaultInteractions } from 'ol/interaction';
import { mapActions, mapGetters, mapState } from 'vuex';
import Draggable from './DraggableContainer.vue';
import MixedChart from './MixedChart.vue';
import DataTable from './DataTable.vue';

export default {
  name: 'Map',
  components: {
    Draggable, MixedChart,
    DataTable,
  },
  data: () => {
    return {
      map: null,
      draggable_open: false,
      siteName: 'N/A',
      tableChartOption: 'Site bar chart summary',
      containerDisplayOptions: ['Site bar chart summary', 'Table summary'],
      layers: [],
      activeVectorLayer: null,
      features: [],
      popup: new OlPopup({
        popupClass: 'default',
        closeBox: false,
        positioning: 'bottom-left',
        offsetBox: [0, 65, 0, 0],
        autoPan: true,
        autoPanAnimation: { duration: 250 },
      }),
      zIndex: 5,
      opacity: 0.8,
      mapSite: null,
      mapCentre: null,
      search: 'site',
      locationSearch: '',
      positionOfXClick: '0',
    };
  },
  computed: {
    ...mapState({
      visibleNodes: (state) => state.datasets.visibleNodes,
      s3Links: (state) => state.datasets.s3Links,
      timeSliderSites: (state) => state.map.timeSliderSites,
      timeSliderYears: (state) => state.map.timeSliderYears,
      selectedYearRange: (state) => state.map.selectedYearRange,
      sliderDisabled: (state) => state.map.sliderDisabled,
    }),
    ...mapGetters([
      'locationList',
      'getMapLocations',
      'colourSettings',
      'currentDataset',
      'getLegendNodes',
      'getLoadStatus',
      'currentLocation',
      'tableData',
      'chartData',
      'getCredentials',
      'getGroupFilteredSites',
      'selectedFeatureTooltipInfo'
    ]),
  },
  watch: {
    currentLocation(location) {
      // fetch links for current location
      this.fetchS3Links({
        prefix: location,
        organisationGUID: '28ccd497-7cad-4470-bd17-721d5cbbd6ef',
      });
    },
    getGroupFilteredSites(n, o) {
      if (n.length > 0 || n.length !== o.length) {
        this.removeLayers();
        this.createMap();
      }
    },
    timeSliderSites() {
      this.removeLayers();
      this.createMap();
    },
    sliderDisabled() {
      this.removeLayers();
      this.createMap();
    },
    mapSite(n) {
      const { popup, map } = this;
      function addPopup(px) {
        let feature = null;
        map.forEachFeatureAtPixel(px, (result) => {
          if (
            result.values_ &&
            result.values_.data.latitude === n.latitude &&
            result.values_.data.longitude === n.longitude
          ) {
            feature = result;
          }
          return result;
        });
        let content = '<div><ul>';
        Object.entries(feature.values_.data).forEach((entry) => {
          const [key, value] = entry;
          if (key !== 'usmart_id') {
            content += `<li>${key}: ${value}</li>`;
          }
          if (this.s3Links.length > 0) {
            this.s3Links.forEach((link) => {
              content += `<li><a href="${link}"></a></li>`;
            });
          }
        });
        content += '</ul></div>';
        popup.offsetBox = [0, 0, 0, 0];
        popup.show(feature.getGeometry().getFirstCoordinate(), content);
      }

      if (n && n.latitude !== 0 && n.longitude !== 0) {
        this.map.getView().animate({
          center: proj.transform(
            [parseFloat(n.longitude), parseFloat(n.latitude)],
            'EPSG:4326',
            'EPSG:3857',
          ),
          duration: 2000,
          zoom: 15,
        });
        this.popup.hide();
        const pixel = this.map.getPixelFromCoordinate(
          proj.transform(
            [parseFloat(n.longitude), parseFloat(n.latitude)],
            'EPSG:4326',
            'EPSG:3857',
          ),
        );
        setTimeout(() => {
          addPopup(pixel, n);
        }, 5000);
      }
    },
    locationList() {
      const titleOfCurrent = this.currentDataset
        ? this.currentDataset.title
        : null;
      this.resetMap(titleOfCurrent);
    },
    visibleNodes() {
      this.toggleNodes();
    },
  },
  mounted() {
    // get the years for year slider
    this.fetchDistinctYears();
    // eslint-disable-next-line no-unused-vars
    const openStreetSource = new XYZ({
      url: 'https://{a-c}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attributions:
        '©<a href="https://www.openstreetmap.org/copyright">OpenStreetMap contributors</a>',
    });
    const satSource = new XYZ({
      url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
      attributions:
        'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
    });
    this.setupLegendNodes(this.colourSettings);
    const { popup } = this;
    this.map = new Map({
      target: 'map',
      layers: [
        new TileLayer({
          source: satSource,
        }),
        new TileLayer({
          source: openStreetSource,
        }),
      ],
      overlays: [popup],
      view: new View({
        center: proj.transform(
          [parseFloat('-0.4651'), parseFloat('52.0030')],
          'EPSG:4326',
          'EPSG:3857',
        ),
        zoom: 11,
      }),
      interactions: defaultInteractions({
        mouseWheelZoom: false,
      }),
    });
    const geocoder = new Geocoder('nominatim', {
      provider: 'osm',
      key: '',
      lang: 'en',
      placeholder: 'Search for ...',
      targetType: 'text-input',
      limit: 5,
      countrycodes: 'gb',
      keepOpen: true,
    });
    geocoder.getLayer().setVisible(false);
    this.map.addControl(geocoder);
  },
  methods: {
    ...mapActions([
      'fetchMapLocations',
      'setupLegendNodes',
      'updateCurrentLocation',
      'fetchS3Links',
      'fetchDistinctYears',
      'fetchSiteSummary',
      'setTargetFeature'
    ]),
    updateSiteName(name) {
      this.siteName = name;
    },
    handleGoogleRedirect(event) {
      event.preventDefault();
      const url = `https://www.google.com/maps/search/?api=1&query=${this.selectedFeatureTooltipInfo.latitude}%2C${this.selectedFeatureTooltipInfo.longitude}`;
      window.open(url, '_blank');
    },
    loadChartData(feature) {
      this.fetchSiteSummary(feature.getProperties().data);
      // this.toggleContainerOpen()
    },
    toggleContainerOpen(option) {
      this.draggable_open = option;
    },
    searchLocation(e) {
      if (e.keyCode === 13) {
        const coords = this.locationSearch.split(',');
        if (coords.length === 2)
          this.map.getView().animate({
            center: proj.transform(
              [parseFloat(coords[1]), parseFloat(coords[0])],
              'EPSG:4326',
              'EPSG:3857',
            ),
            duration: 2000,
            zoom: 15,
          });
      }
    },
    toggleNodes() {
      const toBeVisible = this.getLegendNodes
        .filter((node) => this.visibleNodes.indexOf(node.ID) > -1)
        .map((value) => value.dataset);
      this.toggleLayers(toBeVisible);
    },
    toggleSatLayer() {
      const layers = this.map.getLayers();
      const visibility = layers.array_[1].getVisible();
      layers.array_[1].setVisible(!visibility);
    },
    latLngtext(val) {
      return `${val.latitude},${val.longitude}`;
    },
    toggleSearchLayer(val) {
      this.search = val;
    },
    toggleLayers(names) {
      this.map.getLayers().forEach((layer) => {
        const layerName = layer.get('name');
        if (layerName === 'trafficDataPoints') {
          layer.getLayers().forEach((childLayer) => {
            if (names.indexOf(childLayer.get('name')) > -1) {
              childLayer.setVisible(true);
            } else {
              childLayer.setVisible(false);
            }
          });
        }
      });
    },
    resetMap(current) {
      this.map.getLayers().forEach((layer) => {
        const layerName = layer.get('name');
        if (layerName === 'trafficDataPoints') {
          layer.getLayers().forEach((childLayer) => {
            if (!current) {
              childLayer.setVisible(true);
            } else {
              childLayer.setVisible(false);
              if (childLayer.get('name') === current) {
                childLayer.setVisible(true);
              }
            }
          });
        }
      });
    },
    async createMap() {
      this.$store.commit('loading', true);
      const mapLocations = await this.fetchMapLocations({
        locations: this.locationList,
        groupFilteredSites: this.getGroupFilteredSites,
      });
      if (mapLocations.length === 0) {
        this.$store.commit('loading', false);
        console.error('No locations to display on map');
        return;
      }
      const features = await this.createFeatures(mapLocations);
      const groupedFeatures = this.groupBy(features, 'dataset');
      Object.keys(groupedFeatures).forEach((key) => {
        if (key !== 'TBC') {
          // REMOVE this IF when updated
          const layer = this.createVectorLayer(
            groupedFeatures[key],
            this.getDefaultStyle,
            key,
          );
          this.layers.push(layer);
        }
      });
      this.select = null;
      const ctrl = this;
      this.select = new Select({
        style(feature) {
          ctrl.updateCurrentLocation(feature.values_.data.id);
          const key = feature.values_.data.dataset;
          const style = new Style({
            image: new Circle({
              radius: 12,
              stroke: new Stroke({
                color: '#000',
                width: 5,
              }),
              fill: new Fill({
                color: ctrl.colourSettings[key].color,
              }),
            }),
          });
          return [style];
        },
      });
      this.select.getFeatures().on(['add'], (e) => {
        const { setTargetFeature } = this;
        const feature = e.element;
        setTargetFeature(feature.values_.data);
        this.toggleContainerOpen(true);
        this.loadChartData(feature);
        const siteDesc = feature.values_.data.description;
        this.updateSiteName(siteDesc);
        // const aTag = document.querySelector('.google-redirect');
        // aTag.addEventListener('click', (event) => {
        //   event.preventDefault();
        //   if (!event.target.classList.contains('disable')) {
        //     event.target.classList.add('disable');
        //     window.parent.postMessage({
        //       "action": 'google-redirect',
        //       "url": `http://google.com/maps/search/?api=1&query=${feature.values_.data.latitude}%2C${feature.values_.data.longitude}`,
        //       "authCookie": this.getCredentials.authCookie,
        //     }, process.env.VUE_APP_DOMAIN_URL);
        //     event.target.classList.remove('disable');
        //     return window.open(`http://google.com/maps/search/?api=1&query=${feature.values_.data.latitude}%2C${feature.values_.data.longitude}`, '_blank');
        //   }
        // });
      });
      // this.select.getFeatures().on(['remove'], () => {
      // });
      this.map.addInteraction(this.select);
      this.map.on('click', function (evt) {
        const mapWidth = document.getElementById("map").clientWidth;
        const clickedLocation = evt.originalEvent.clientX;
        const threeColsWidth = Math.floor(mapWidth / 3);
        ctrl.positionOfXClick = clickedLocation < threeColsWidth || clickedLocation > threeColsWidth * 2 ? '50%' : '2%';
      })
      const group = new LayerGroup({ layers: this.layers });
      group.set('name', 'trafficDataPoints');
      this.map.addLayer(group);
      this.map.getLayers()
      this.toggleNodes();
      this.$store.commit('loading', false);
    },
    groupBy(array, key) {
      return array.reduce((result, currentValue) => {
        // If an array already present for key, push it to the array. Else create an array and push the object
        (result[currentValue.values_.data[key]] =
          result[currentValue.values_.data[key]] || []).push(currentValue);
        // Return the current iteration `result` value, this will be taken as next iteration `result` value and accumulate
        return result;
      }, {}); // empty object is the initial value for result object
    },
    getDefaultStyle(key) {
      const style = new Style({
        image: new Circle({
          radius: 6,
          stroke: new Stroke({
            color: 'white',
            width: 2,
          }),
          fill: new Fill({
            color: this.colourSettings[key].color,
          }),
        }),
      });
      return [style];
    },
    createFeatures(dataPoints) {
      this.features = [];
      dataPoints.forEach((point) => {
        if (
          point.longitude &&
          point.longitude !== 0 &&
          point.latitude &&
          point.latitude !== 0
        ) {
          const latLongCoord = [point.longitude, point.latitude];
          const googleCoord = proj.transform(
            latLongCoord,
            'EPSG:4326',
            'EPSG:3857',
          );
          const geometry = new Point(googleCoord);
          const feature = new Feature({
            geometry,
            data: point,
          });
          this.features.push(feature);
        }
      });
      return this.features;
    },
    createVectorLayer(features, fetchStyle, key, cluster) {
      const src = new Vector({ features });
      const clusterSrc = new Cluster({
        distance: 60,
        source: src,
      });
      const layer = new LayerVector({
        source: cluster ? clusterSrc : src,
        style: () => fetchStyle(key),
      });
      layer.set('name', key);
      return layer;
    },
    removeLayers() {
      this.layers = [];
      if (this.map.getLayers().getLength() > 2) {
        this.map.getLayers().forEach((layer) => {
          if (layer instanceof LayerGroup) {
            this.map.removeLayer(layer);
          }
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
#map {
  height: 500px;
}

.site-location-search-input {
  position: absolute;
  width: 21em;
  z-index: 7;
  top: 1.3em;
  right: calc(2vw + 8em)
}

.btnCont {
  display: flex;
  margin-top: 20px;
  width: 100%;
  justify-content: space-between;
}

#layerctrl {
  position: absolute;
  z-index: 99;
  top: 2em;
  right: 3em;
}

.google-redirect {
  color: #02466b;
}

@media (min-width: 360px) {
  .card-style-title {
    font-size: 2em;
    justify-content: center;
  }

  .btnCont {
    width: 100%;
    justify-content: space-between;
  }
}

@media (min-width: 650px) {
  .card-style-title {
    font-size: 2.5em;
    justify-content: space-between;
    margin: 10px;
  }

  .btnCont {
    justify-content: flex-end;
    width: auto;
    margin: 0;
  }
}
</style>
